import clsx from "clsx";
import { FC } from "react";

type LimitFunctionTableHeadProps = {
  name: string;
  target: string;
  bgColor?: string;
};

const LimitFunctionTableHead: FC<LimitFunctionTableHeadProps> = ({
  name,
  target,
  bgColor,
}) => {
  return (
    <th
      className={clsx("space-y-4 p-16")}
      style={{
        backgroundColor: bgColor,
      }}
    >
      <p className="text-xs">無料</p>
      <p className="font-bold">{name}</p>
      <p className="text-xs">{target}</p>
    </th>
  );
};
export default LimitFunctionTableHead;
